"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _antd = require("antd");
var _Icon = _interopRequireDefault(require("../Icon"));
var _StretchList = require("./StretchList.style");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * 可伸展的列表內含checkbox功能呦
 */
const CheckGroup = _antd.Checkbox.Group;
const {
  Panel
} = _antd.Collapse;
const noop = () => {};
const StretchList = _ref => {
  let {
    title = "",
    data = [],
    checkedList = [],
    isCheckType = true,
    onChange = noop,
    className,
    mt,
    mb,
    onClick = noop
  } = _ref;
  const [indeterminate, setIndeterminate] = (0, _react.useState)(false);
  const [checkAll, setCheckAll] = (0, _react.useState)(false);
  const onChangeHandle = list => {
    onChange(list);
    onClick(...list);
    setIndeterminate(!!list.length && list.length < data.length);
    setCheckAll(list.length === data.length);
  };
  const onCheckAllChangeHandle = e => {
    const list = e.target.checked ? data.map(item => item.value) : [];
    onChange(list);
    onClick(...list);
    setIndeterminate(false);
    setCheckAll(e.target.checked);
  };
  const renderIcon = isActive => {
    return /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "arrow_drop_up",
      rotate: isActive ? 0 : 180,
      color: "#1890ff"
    });
  };
  (0, _react.useEffect)(() => {
    if (checkedList.length === 0) {
      setIndeterminate(false);
      setCheckAll(false);
    } else {
      setIndeterminate(!!checkedList.length && checkedList.length < data.length);
      setCheckAll(checkedList.length === data.length);
    }
  }, [checkedList]);
  return /*#__PURE__*/_react.default.createElement(_StretchList.UiStretchBox, {
    className: className,
    mt: mt,
    mb: mb
  }, /*#__PURE__*/_react.default.createElement(_antd.Collapse, {
    expandIcon: _ref2 => {
      let {
        isActive
      } = _ref2;
      return renderIcon(isActive);
    }
  }, /*#__PURE__*/_react.default.createElement(Panel, {
    key: "1",
    header: /*#__PURE__*/_react.default.createElement(_StretchList.UiStretchTitle, null, isCheckType && /*#__PURE__*/_react.default.createElement(_antd.Checkbox, {
      indeterminate: indeterminate,
      onChange: onCheckAllChangeHandle,
      checked: checkAll,
      onClick: e => {
        e.stopPropagation();
      }
    }), title)
  }, /*#__PURE__*/_react.default.createElement(CheckGroup, {
    value: checkedList,
    onChange: onChangeHandle
  }, data.length > 0 && data.map((item, index) => {
    return /*#__PURE__*/_react.default.createElement(_StretchList.UiStretchItem, {
      key: index
    }, isCheckType ? /*#__PURE__*/_react.default.createElement(_antd.Checkbox, {
      value: item.value
    }, item.label) : /*#__PURE__*/_react.default.createElement("span", null, item.label));
  })))));
};
var _default = exports.default = StretchList;
StretchList.propTypes = {
  title: _propTypes.default.string,
  code: _propTypes.default.string,
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.any
  })).isRequired,
  isCheckType: _propTypes.default.bool,
  checkedList: _propTypes.default.array,
  onChange: _propTypes.default.func,
  onClick: _propTypes.default.func,
  className: _propTypes.default.string,
  mt: _propTypes.default.string,
  mb: _propTypes.default.string
};